export function extractTopicFromUri(uri: string) {
    const match = uri.match(/^wc:([0-9a-fA-F]+)@/);
    return match ? match[1] : null;
}
